module.exports = __webpack_public_path__ + "img/588x310-03.bd8187c6.png";